import { __assign } from "tslib";
// tslint:disable-next-line: max-line-length
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createWidgetSettingsApi } from './';
import { createHttpTestKit } from '../../http/test-kit';
// tslint:disable-next-line: max-line-length
import { WidgetContactType } from './domain';
export var createWidgetSettingsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWidgetSettingsApi('', fakeHttp);
    var baseUrl = '/widgets';
    var widgetSettingsUrl = function (widgetId) { return "".concat(baseUrl, "/").concat(widgetId, "/new-settings"); };
    var widgetContentUrl = function (widgetId, locale) { return "".concat(widgetSettingsUrl(widgetId), "/content/").concat(locale); };
    var chatModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/chat"); };
    var contactFormModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/form"); };
    var phoneModuleUrl = function (widgetId, locale) { return "".concat(widgetContentUrl(widgetId, locale), "/contacts/channel/callback"); };
    var answersOrigin;
    try {
        var origin_1 = new URL(baseUrl).origin;
        answersOrigin = origin_1;
    }
    catch (_a) {
        answersOrigin = '';
    }
    var widgetServiceUrl = "".concat(answersOrigin, "/apps/widget/v1");
    var testKit = {
        whenGetAll: function () { return createFakeGetResponder(fakeHttp, "".concat(baseUrl, "/list")); },
        whenCreate: function (dto) { return createFakePostResponder(fakeHttp, "".concat(baseUrl, "/add"))(dto); },
        whenDelete: function (dto) { return createFakeDeleteResponder(fakeHttp, "".concat(baseUrl, "/").concat(dto.id)); },
        whenRename: function (dto) { return createFakePutResponder(fakeHttp, "".concat(baseUrl, "/").concat(dto.id, "/rename"))({ name: dto.name }); },
        whenEnable: function (dto) { return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/enable"))({}); },
        whenDisable: function (dto) { return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/disable"))({}); },
        whenGetDesign: function (dto) { return createFakeGetResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/appearance")); },
        whenSetDesign: function (dto) { return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/appearance"))(dto); },
        whenGetAdvanced: function (dto) { return createFakeGetResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced")); },
        whenSetAllowedDomains: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/domains"))({ domains: dto.domains });
        },
        whenSetRequiredAuthenticationEnabled: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/authenticationEnabled"))(dto);
        },
        whenGetCustomText: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/").concat(dto.locale, "/texts"));
        },
        whenSetCustomText: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/").concat(dto.locale, "/texts"))({
                texts: dto.texts
            });
        },
        whenGetCustomJs: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/js"));
        },
        whenSetCustomJs: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/js"))({ content: dto.content });
        },
        whenGetCustomCss: function (dto) {
            return createFakeGetResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/css"));
        },
        whenSetCustomCss: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/advanced/css"))({ content: dto.content });
        },
        whenSetOpeningHours: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/contacts/openingHours"))(dto);
        },
        whenSetAllContactsOpeningHours: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/contacts/openingHours/all"))(dto);
        },
        whenUpdateWidgetSchedule: function (dto) { return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/contacts/schedule"))(dto); },
        whenSetContentSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale))(dto);
        },
        whenSetChatSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(chatModuleUrl(dto.id, dto.locale)))({
                settings: dto.settings
            });
        },
        whenSetContactFormSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(contactFormModuleUrl(dto.id, dto.locale)))({
                settings: dto.settings
            });
        },
        whenSetCallbackSettings: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(phoneModuleUrl(dto.id, dto.locale)))(dto);
        },
        whenSetContentScope: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/contentScope"))({
                contentScope: dto.contentScope,
                applyToAllLanguages: dto.applyToAllLanguages
            });
        },
        whenAddModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules"))({
                moduleType: dto.moduleType
            });
        },
        whenRemoveModule: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/").concat(dto.moduleId));
        },
        whenReorderModules: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/reorder"))({
                dto: dto
            });
        },
        whenEnableChatModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(chatModuleUrl(dto.id, dto.locale), "/enable"))({
                contactType: WidgetContactType.CHAT
            });
        },
        whenDisableChatModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(chatModuleUrl(dto.id, dto.locale), "/disable"))({
                contactType: WidgetContactType.CHAT
            });
        },
        whenEnableContactFormModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(contactFormModuleUrl(dto.id, dto.locale), "/enable"))({
                contactType: WidgetContactType.CONTACT_FORM
            });
        },
        whenDisableContactFormModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(contactFormModuleUrl(dto.id, dto.locale), "/disable"))({
                contactType: WidgetContactType.CONTACT_FORM
            });
        },
        whenEnableLimitContactExposure: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/exposure/enable"))(dto);
        },
        whenDisableLimitContactExposure: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(widgetContentUrl(dto.id, dto.locale), "/contacts/exposure/disable"))(dto);
        },
        whenEnablePhoneModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(phoneModuleUrl(dto.id, dto.locale), "/enable"))({
                contactType: WidgetContactType.CALLBACK
            });
        },
        whenDisablePhoneModule: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(phoneModuleUrl(dto.id, dto.locale), "/disable"))({
                contactType: WidgetContactType.CALLBACK
            });
        },
        whenSetSearchBarTitle: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/searchBar/title"))({
                title: dto.title
            });
        },
        whenSetFeaturedArticleTitle: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/featuredArticles/title"))({
                dto: dto
            });
        },
        whenAddFeaturedArticle: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/featuredArticles"))({
                dto: dto
            });
        },
        whenRemoveFeaturedArticle: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakeDeleteResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/featuredArticles?locale=").concat(dto.locale, "&id=").concat(dto.id, "&articleId=").concat(dto.articleId));
        },
        whenReorderFeaturedArticles: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/featuredArticles/reorder"))({
                dto: dto
            });
        },
        whenSetCategoriesListTitle: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/categories/title"))({
                title: dto.title
            });
        },
        whenSetCustomHtmlModuleContent: function (dto) {
            // tslint:disable-next-line: max-line-length
            return createFakePutResponder(fakeHttp, "".concat(widgetSettingsUrl(dto.id), "/content/").concat(dto.locale, "/modules/html/").concat(dto.moduleId))(dto);
        },
        whenEnableChatContacts: function () { return createFakeGetResponder(fakeHttp, "".concat(baseUrl, "/enabledChatContacts")); },
        whenGetTranslations: function (dto) { return createFakeGetResponder(fakeHttp, "".concat(widgetServiceUrl, "/translations/").concat(dto.locale)); },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map